import { createFileRoute, useNavigate } from '@tanstack/react-router'

import { RichObjectDrawer } from '@/features/rich-objects/RichObjectView'
import { RICH_NODE_ID_PATTERN } from '@/api/validation/rich-objects.schemas'
import { useAgentStore } from '@/stores/agent.store'

/** A rich object's full view: a drawer over the chat, at one part when `node` names it. */
function RichObjectRoute() {
  const { projectId, objectId } = Route.useParams()
  const { node } = Route.useSearch()
  const navigate = useNavigate()
  // Closing returns to the chat it was opened from; a direct link lands in Bru.
  const agentId = useAgentStore((state) => state.activeAgentId) ?? 'bru'
  return (
    <RichObjectDrawer
      projectId={projectId}
      objectId={objectId}
      nodeId={node ?? null}
      onSelectNode={(nodeId) => void navigate({ to: '/$projectId/objects/$objectId', params: { projectId, objectId }, search: { node: nodeId }, replace: true })}
      onClose={() => void navigate({ to: '/$projectId/$agentId', params: { projectId, agentId } })}
    />
  )
}

export const Route = createFileRoute('/_app/$projectId/objects/$objectId')({
  // Only a well-formed part id survives; anything else opens the whole object.
  validateSearch: (search: Record<string, unknown>): { node?: string } =>
    typeof search.node === 'string' && RICH_NODE_ID_PATTERN.test(search.node) ? { node: search.node } : {},
  component: RichObjectRoute,
})
